// import package
import React, { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SocketContext from "../Context/SocketContext";
// import action
import {
  getBankDetail,
  getUserSetting,
  viewUserProfile,
  getUPIDetail,
  getQRDetail,
  logout,
} from "../../actions/users";
import {
  getPriceConversion,
  getCurrency,
  getANNC,
} from "../../actions/commonAction";
import { getAssetData } from "../../actions/walletAction";
import { getKycDetail } from "../../actions/userKyc";
import { getCopyTradeSettings } from "../../actions/copyTradeAction";

const HelperRoute = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const socketContext = useContext(SocketContext);
  // redux-state
  const { isAuth } = useSelector((state) => state.auth);
  const currencyOption = useSelector((state) => state.currency);

  // function
  useEffect(() => {
    if (isAuth) {
      getUserSetting(dispatch);
      getBankDetail(dispatch);
      getAssetData(dispatch);
      viewUserProfile(dispatch);
      getPriceConversion(dispatch);
      getANNC(dispatch);
      getKycDetail(dispatch);
      getPriceConversion(dispatch);
      getUPIDetail(dispatch);
      getQRDetail(dispatch);
    }
  }, [isAuth]);

  useEffect(() => {
    if (!(currencyOption && currencyOption.length > 0)) {
      getCurrency(dispatch);
    }
    getCopyTradeSettings(dispatch);

    socketContext.socket.on("FORCE_LOGOUT", (result) => {
      logout(history, dispatch);
    });
  }, []);

  return <div />;
};

export default HelperRoute;
